import React from 'react'
import CommonFooter from '../../components/CommonFooter/CommonFooter'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'

const FarmerBrand = () => {
  return (
    <>
      <CommonNavbar />
      <div>
        <div className='py-5'>
          <div className='container px-md-5'>
            <div className='max-w-5xl mx-auto text-gray-800 leading-relaxed'>
              {/* Title */}
              <h1 className='text-3xl font-bold mb-4 text-clr_dark_green clr_dark_green'>
                Farmer Brands by Farmer’s City
              </h1>

              {/* Intro */}
              <p className='mb-6'>
                Farmer’s City, an AVPL International subsidiary and aggregator
                of agri-tech startups, introduces Farmer Brands as its own
                labeled products aimed at enhancing the agricultural value chain
                and providing quality offerings to farmers and consumers. These
                Farmer Brands products are designed to meet the diverse needs of
                farmers, promote sustainable practices, and ensure product
                integrity throughout the supply chain.
              </p>

              {/* Product Range */}
              <section className='mb-8'>
                <h2 className='text-2xl font-semibold mb-3 text-clr_dark_green clr_dark_green'>
                  Farmer Brands Product Range
                </h2>
                <p className='mb-2'>
                  <strong>Agri Inputs:</strong> Farmer Brands offers a range of
                  agricultural inputs such as seeds, fertilizers, pesticides,
                  and farm equipment tailored to optimize crop yields and
                  enhance farming efficiency.
                </p>
                <p className='mb-2'>
                  <strong>Agri Outputs:</strong> From fresh produce to processed
                  goods, Farmer Brands encompasses a variety of agricultural
                  outputs including grains, fruits, vegetables, and value-added
                  products sourced directly from farmers within the Farmer’s
                  City network.
                </p>
                <p className='mb-2'>
                  <strong>Livestock Products:</strong> Farmer Brands includes
                  livestock-related products such as animal feed, supplements,
                  healthcare items, and accessories to support animal husbandry
                  practices and ensure animal welfare.
                </p>
                <p className='mb-2'>
                  <strong>Drone Services:</strong> Under the Farmer Brands
                  umbrella, drone-based services for crop spraying,
                  surveillance, and land mapping are offered to enhance
                  precision agriculture practices and improve farm productivity.
                </p>
              </section>

              {/* Quality Assurance */}
              <section className='mb-8'>
                <h2 className='text-2xl font-semibold mb-3 text-clr_dark_green clr_dark_green'>
                  Quality Assurance of Farmer Brands
                </h2>
                <p className='mb-2'>
                  <strong>Certifications:</strong> Farmer Brands products
                  undergo rigorous quality assurance processes to meet industry
                  standards and regulatory requirements, ensuring traceability
                  and authenticity.
                </p>
                <p className='mb-2'>
                  <strong>Testing:</strong> Through partnerships with accredited
                  laboratories and quality assaying services, Farmer Brands
                  products are tested for purity, safety, and compliance with
                  established guidelines.
                </p>
                <p className='mb-2'>
                  <strong>Traceability:</strong> Farmer Brands implements
                  traceability measures to track the journey of products from
                  farm to table, providing transparency to consumers and
                  building trust in the brand.
                </p>
              </section>

              {/* Sustainability */}
              <section className='mb-8'>
                <h2 className='text-2xl font-semibold mb-3 text-clr_dark_green clr_dark_green'>
                  Sustainability Initiatives
                </h2>
                <p className='mb-2'>
                  <strong>Organic Options:</strong> Farmer Brands includes
                  organic and sustainable agriculture products to support
                  environmentally friendly farming practices and cater to the
                  growing demand for organic produce.
                </p>
                <p className='mb-2'>
                  <strong>Fair Trade Practices:</strong> By promoting fair trade
                  principles in sourcing raw materials from farmers, Farmer
                  Brands contributes to equitable partnerships and supports
                  rural livelihoods.
                </p>
              </section>

              {/* Consumer Engagement */}
              <section className='mb-8'>
                <h2 className='text-2xl font-semibold mb-3 text-clr_dark_green clr_dark_green'>
                  Consumer Engagement
                </h2>
                <p className='mb-2'>
                  <strong>Direct-to-Consumer Model:</strong> Through digital
                  platforms and physical stores, Farmer Brands engages directly
                  with consumers, offering them access to high-quality
                  agricultural products while fostering a sense of community
                  between farmers and buyers.
                </p>
                <p className='mb-2'>
                  <strong>Educational Initiatives:</strong> Farmer Brands
                  educates consumers about the origin, benefits, and production
                  methods of its products, promoting awareness about sustainable
                  agriculture practices and ethical sourcing.
                </p>
              </section>

              {/* Conclusion */}
              <section>
                <h2 className='text-2xl font-semibold mb-3 text-clr_dark_green clr_dark_green'>
                  Conclusion
                </h2>
                <p>
                  In conclusion, Farmer Brands by Farmer’s City represents a
                  commitment to quality, sustainability, and community
                  engagement within the agricultural sector. By offering a
                  diverse range of products under its own label, Farmer’s City
                  aims to empower farmers, promote responsible consumption, and
                  build a resilient agricultural ecosystem that benefits all
                  stakeholders involved.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
    </>
  )
}

export default FarmerBrand
